import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/img/primary-button-icon.png'


const _hoisted_1 = {
  key: 0,
  class: "mt-6 overflow-x-auto"
}
const _hoisted_2 = { class: "text-3xl font-medium capitalize" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = {
  key: 1,
  class: "mt-6 overflow-x-auto"
}
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-4xl font-medium" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "text-4xl font-medium" }
const _hoisted_10 = { class: "flex w-full p-10 my-6 space-x-5 bg-play-peach" }
const _hoisted_11 = { class: "w-4/5 text-2xl font-medium" }
const _hoisted_12 = { class: "flex items-center w-1/5 space-x-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_16 = { class: "text-4xl font-medium" }
const _hoisted_17 = { class: "flex mt-4 overflow-x-auto" }
const _hoisted_18 = ["data"]
const _hoisted_19 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_20 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_21 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_22 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_23 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_26 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_27 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_28 = { class: "flex px-2 py-6 space-x-2 capitalize md:py-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_30 = { class: "px-2 py-2 capitalize" }
const _hoisted_31 = { class: "px-2 py-2 capitalize" }
const _hoisted_32 = { class: "px-2 py-2 capitalize" }
const _hoisted_33 = { class: "px-2 py-2 capitalize" }
const _hoisted_34 = { class: "px-2 py-2" }
const _hoisted_35 = { class: "mt-6" }
const _hoisted_36 = { class: "flex items-center justify-between" }
const _hoisted_37 = { class: "text-4xl font-medium capitalize" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import TitleHeader from "../TitleHeader.vue";
import TimezoneSpan from "../TimezoneSpan.vue";
import UsersTable from "../tables/UsersTable.vue";
import RouterButton from "@/components/RouterButton.vue";
import AggregatedGoalsTable from "@/components/tables/AggregatedGoalsTable.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import EventsTable from "../tables/EventsTable.vue";

import api from "@/api/api";
import { Club, Event, User } from "@/types";
import { PaginationMeta, Resource } from "@/types";
import ResourceCards from "../resources/ResourceCards.vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'FacilitatorOrganisationDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { user } = storeToRefs(useUserStore());

const website_url = process.env.VUE_APP_WEBSITE_URL;

const events = ref([] as Event[]);
const resources = ref([] as Resource[]);

const users = ref([] as User[]);
const meta = ref({} as PaginationMeta);

const clubs = ref([] as Club[]);

const satisfaction = ref(0);

async function listClubs() {
  const response = await api.clubs.listClubs({
    page: String(route.query.page),
  });
  clubs.value = response.data.clubs;
}

async function listResources() {
  const response = await api.resources.listResources({
    page: 1,
    role: "facilitator-organisation",
  });
  resources.value = response.data.resources;
  if (resources.value.length > 3) resources.value = resources.value.slice(0, 3);
}

async function listUsers() {
  const response = await api.users.listUsers({
    page: 1,
    roles: ["certified-facilitator-trainee", "certified-facilitator", "advanced-facilitator-trainee", "advanced-facilitator"],
  });
  users.value = response.data.users;
  meta.value = response.meta;
}

async function getSatisfaction() {
  const res = await api.surveys.getSurveySatifactionClubOverall();
  satisfaction.value = res?.data?.overallScore;
}

events.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.events.listEvents({
  page: 1,
  status: "published",
  added_by_user: true
}))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.events;

if (user.value.has_brick_club_access) {
  (
  ([__temp,__restore] = _withAsyncContext(() => listClubs())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => getSatisfaction())),
  await __temp,
  __restore()
);
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listUsers())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listResources())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    (_unref(user).has_smartsurvey_access && _unref(user).has_brick_club_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("average-brick-club-session-feedback")) + " " + _toDisplayString(_ctx.$t("out-of-10")) + ": " + _toDisplayString(satisfaction.value), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ExternalLink, {
              type: "text",
              label: _ctx.$t('what-does-this-mean'),
              href: `${_unref(website_url)}/howto`,
              capitalize: false
            }, null, 8, ["label", "href"])
          ]),
          _createVNode(RouterButton, {
            to: { name: 'Satisfaction_Survey_Club' },
            type: "primary",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("view-satisfaction-breakdown")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(user).has_smartsurvey_access && _unref(user).has_brick_club_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("goal-based-outcomes")), 1)
          ]),
          _createVNode(AggregatedGoalsTable)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("facilitators")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Users' },
          type: "primary",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view-all-users")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(UsersTable, {
        users: users.value.splice(0, 5),
        meta: meta.value,
        hide_pagination: true
      }, null, 8, ["users", "meta"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t("courses-cta")), 1),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("a", {
          href: `${_unref(website_url)}/courses/register-for-a-training-course/`,
          target: "_blank",
          class: "text-[16px] font-medium"
        }, _toDisplayString(_ctx.$t("view-courses")), 9, _hoisted_14)
      ])
    ]),
    (_unref(user).has_brick_club_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t("your-brick-clubs")), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", {
              data: clubs.value,
              class: "w-full table-fixed"
            }, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_19, [
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t(`name`)), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t(`date`)), 1),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t(`facilitator`)), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t(`location`)), 1),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t(`setting`)), 1),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t(`status`)), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("actions")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value, (club) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 divide-x divide-gray-300",
                    key: club.id
                  }, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(club.name), 1),
                    _createElementVNode("td", _hoisted_28, [
                      _createVNode(TimezoneSpan, {
                        date: club.first_club_date,
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "long",
                        showTime: false
                      }, null, 8, ["date"]),
                      _hoisted_29,
                      _createVNode(TimezoneSpan, {
                        date: club.last_club_date,
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "long",
                        showTime: false
                      }, null, 8, ["date"])
                    ]),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(club.facilitator.first_name) + " " + _toDisplayString(club.facilitator.last_name), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(`${club.address_line_one} ${club.address_line_two !== null ? `, ${club.address_line_two}` : ""}, ${club.city}, ${club.postcode}, ${club.country}`), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(club.setting), 1),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(club.status), 1),
                    _createElementVNode("td", _hoisted_34, [
                      _createVNode(_component_router_link, {
                        to: `/dashboard/clubs/${club.id}`,
                        class: "text-blue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("view-club-details")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ], 8, _hoisted_18)
          ]),
          _createVNode(RouterButton, {
            to: { name: 'Brick_Clubs' },
            type: "primary",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("view-all-clubs")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("h2", _hoisted_37, _toDisplayString(_ctx.$t("training-events")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Training_Events' },
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("see-all-training-events")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(EventsTable, {
        events: events.value.slice(0, 5),
        class: "mt-8"
      }, null, 8, ["events"])
    ]),
    _createVNode(ResourceCards, {
      role: "Brick-by-Brick® Group Admin",
      resources: resources.value.splice(0, 3)
    }, null, 8, ["resources"])
  ], 64))
}
}

})